var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignuparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 55,
    viewBox: "0 0 62 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 28,
    r: 18,
    transform: "rotate(-90 31 28)",
    fill: "#A2CE4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0607 29.0607C41.6464 28.4749 41.6464 27.5251 41.0607 26.9393L31.5147 17.3934C30.9289 16.8076 29.9792 16.8076 29.3934 17.3934C28.8076 17.9792 28.8076 18.9289 29.3934 19.5147L37.8787 28L29.3934 36.4853C28.8076 37.0711 28.8076 38.0208 29.3934 38.6066C29.9792 39.1924 30.9289 39.1924 31.5147 38.6066L41.0607 29.0607ZM22 29.5L40 29.5L40 26.5L22 26.5L22 29.5Z",
    fill: "#2C4530"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignuparrow);
export default __webpack_public_path__ + "static/media/signuparrow.98cd18028651fa4e7c618444efb19fdb.svg";
export { ForwardRef as ReactComponent };